import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { DialogProps } from "../misc/DialogProps";
import { AutovioCalendarEvent } from "../model/autovioCalendarEvents";
import { useEventDialog } from "../hooks/useEventDialog";
import { listContextFromArray } from "../utils/listContextFromArray";
import { Datagrid, FunctionField, ListContextProvider, useRecordContext } from "react-admin";
import { cloneElement, ReactElement } from "react";
import { autovioColors } from "../misc/backofficeTheme";
import { DateField } from "../fields/DateField";
import { InstructorField } from "../fields/InstructorField";
import { calendarEventTitle } from "../utils/calendar";
import { StudentAttendanceLogic } from "../model/StudentAttendanceLogic";
import { LocationField } from "../fields/LocationField";

export function StudentDayDialog(props: { studentId: string; events: Array<AutovioCalendarEvent> } & DialogProps) {
  const { studentId, events, ...dialogProps } = props;
  const { openEventDialog, eventDialog } = useEventDialog({ syncWithUrl: false });
  return (
    <>
      <Dialog {...dialogProps} fullWidth maxWidth="sm">
        <DialogTitle>{events[0]?.start.setLocale("de-DE").toFormat("EEEE, d. MMMM yyyy")}</DialogTitle>
        <DialogCloseButton onClick={dialogProps.onClose} />
        <DialogContent>
          <ListContextProvider value={listContextFromArray(events)}>
            <Datagrid
              bulkActionButtons={false}
              rowClick={(_, __, event) => openEventDialog(event as AutovioCalendarEvent)}
            >
              <_StyleEventWrapper label="Uhrzeit" studentId={studentId}>
                <DateField source="start" showDate={false} showTime />
              </_StyleEventWrapper>
              <_StyleEventWrapper label="Art" studentId={studentId}>
                <FunctionField render={(event: AutovioCalendarEvent) => calendarEventTitle(event)} />
              </_StyleEventWrapper>
              <_StyleEventWrapper label="Fahrlehrer" studentId={studentId}>
                <InstructorField source="instructorId" />
              </_StyleEventWrapper>
              <_StyleEventWrapper label="Ort" studentId={studentId}>
                <LocationField />
              </_StyleEventWrapper>
            </Datagrid>
          </ListContextProvider>
        </DialogContent>
      </Dialog>
      {eventDialog}
    </>
  );
}

function _StyleEventWrapper(props: { children: ReactElement; label: string; studentId: string }) {
  const { children, studentId } = props;
  const event = useRecordContext<AutovioCalendarEvent>();

  if (!event) {
    return null;
  }

  if (StudentAttendanceLogic.attended(event, studentId)) {
    return cloneElement(children, { sx: { color: autovioColors.green } });
  } else if (StudentAttendanceLogic.canceledOrNoShow(event, studentId)) {
    return cloneElement(children, { sx: { color: autovioColors.red } });
  } else {
    return children;
  }
}
